import { withTranslation } from 'react-i18next';

export default (Component) => withTranslation()(Component);
